const toSnakeCase = (string = "") =>
  string
    .replace(/\W+/g, " ")
    .split(/ |\B(?=[A-Z])/)
    .map((word) => word.toLowerCase())
    .join("_");
export default toSnakeCase;

export const toCrazySnakeCase = (string = "") => toSnakeCase(string).toUpperCase();
